import { createFileRoute } from "@tanstack/react-router";
import { getCliAuth } from "@/features/identity/records";
import { cliSearchSchema } from "@/features/identity/navigation";
import { CliAuthPage } from "@/features/identity";
import { VerifiedSession } from "@/session/product-session";

export const Route = createFileRoute("/_site/cli-auth/")({
  validateSearch: cliSearchSchema,
  loaderDeps: ({ search }) => search,
  loader: ({ deps, abortController }) =>
    getCliAuth({ data: deps, signal: abortController.signal }),
  gcTime: 0,
  head: () => ({
    meta: [
      { title: "Softmax CLI sign-in" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: CliAuthRoute,
});

function CliAuthRoute() {
  const admission = Route.useLoaderData();

  if (admission.kind === "ready" || admission.kind === "profile") {
    return (
      <VerifiedSession sessionUserId={admission.sessionUserId}>
        <CliAuthPage
          key={JSON.stringify([admission.sessionUserId, admission.callback])}
          admission={admission}
        />
      </VerifiedSession>
    );
  }

  return (
    <CliAuthPage
      key={JSON.stringify([
        admission.kind,
        admission.kind === "anonymous" ? admission.callback : null,
      ])}
      admission={admission}
    />
  );
}
